import {AS_BUSINESS_UNIT_TYPE} from "~/constants/businessUnit";
import {User} from "~/models/auth";

export const getIsAsUser = (user: Ref<User | undefined>) => {
    return computed(() => user.value?.BusinessUnitType === AS_BUSINESS_UNIT_TYPE)
}
